export const BANK_SERVICE_TYPES = [
    {
        label: "Emissão de boletos",
        value: "invoices",
    },
    {
        label: "Custódia de cheque",
        value: "checkCustody",
    },
];

export const PAYABLE_TYPE_LIST = [
    {
        label: "Duplicata",
        value: "DUPLICATA",
    },
    {
        label: "Cheque",
        value: "CHEQUE",
    },
    {
        label: "Nota promissória",
        value: "NOTA_PROMISSORIA",
    },
];

export const featureFlags = {
    ENABLE_STANDARD_EXPRESS_OPERATIONS: "enable-standard-express-operations",
    ENABLE_CHECKING_ACCOUNT: "enable-checking-account",
} as const;
